import { z } from 'zod';

export const CategoryWallpaperRow = z.object({
  category_id: z.number().int().positive(),
  wallpaper_id: z.number().int().positive(),
  is_default: z.boolean(),
});
export type CategoryWallpaper = z.infer<typeof CategoryWallpaperRow>;

// Each wallpaper belongs to 1-3 categories.
// Primary category is parent_category_id from wallpapers.
// Additional assignments: styles, colors, combi.
// Cat ids:
//  themes: 1=kwiaty,2=morze,3=gory,4=miasto,5=abstrakcja
//  rooms:  6=salon,7=sypialnia,8=kuchnia,9=lazienka,10=gabinet
//  styles: 11=nowoczesny,12=skandynawski,13=loft,14=klasyczny
//  colors: 15=niebieski,16=szary,17=bialy,18=zielony
//  combi:  19=kwiaty-w-salonie,20=morze-niebieski
export const CATEGORIES_WALLPAPERS: readonly CategoryWallpaper[] = [
  // kwiaty (1001-1005) — also: green/white, scandinavian
  { category_id: 1, wallpaper_id: 1001, is_default: true },
  { category_id: 18, wallpaper_id: 1001, is_default: false }, // zielony
  { category_id: 12, wallpaper_id: 1001, is_default: false }, // skandynawski
  { category_id: 1, wallpaper_id: 1002, is_default: true },
  { category_id: 17, wallpaper_id: 1002, is_default: false }, // bialy
  { category_id: 1, wallpaper_id: 1003, is_default: true },
  { category_id: 18, wallpaper_id: 1003, is_default: false }, // zielony
  { category_id: 19, wallpaper_id: 1003, is_default: false }, // kwiaty-w-salonie
  { category_id: 1, wallpaper_id: 1004, is_default: true },
  { category_id: 14, wallpaper_id: 1004, is_default: false }, // klasyczny
  { category_id: 1, wallpaper_id: 1005, is_default: true },
  { category_id: 17, wallpaper_id: 1005, is_default: false }, // bialy
  // morze (1006-1010) — blue
  { category_id: 2, wallpaper_id: 1006, is_default: true },
  { category_id: 15, wallpaper_id: 1006, is_default: false }, // niebieski
  { category_id: 20, wallpaper_id: 1006, is_default: false }, // morze-niebieski
  { category_id: 2, wallpaper_id: 1007, is_default: true },
  { category_id: 15, wallpaper_id: 1007, is_default: false }, // niebieski
  { category_id: 2, wallpaper_id: 1008, is_default: true },
  { category_id: 11, wallpaper_id: 1008, is_default: false }, // nowoczesny
  { category_id: 2, wallpaper_id: 1009, is_default: true },
  { category_id: 15, wallpaper_id: 1009, is_default: false }, // niebieski
  { category_id: 20, wallpaper_id: 1009, is_default: false }, // morze-niebieski
  { category_id: 2, wallpaper_id: 1010, is_default: true },
  // gory (1011-1015) — grey/white
  { category_id: 3, wallpaper_id: 1011, is_default: true },
  { category_id: 16, wallpaper_id: 1011, is_default: false }, // szary
  { category_id: 3, wallpaper_id: 1012, is_default: true },
  { category_id: 17, wallpaper_id: 1012, is_default: false }, // bialy
  { category_id: 12, wallpaper_id: 1012, is_default: false }, // skandynawski
  { category_id: 3, wallpaper_id: 1013, is_default: true },
  { category_id: 16, wallpaper_id: 1013, is_default: false }, // szary
  { category_id: 3, wallpaper_id: 1014, is_default: true },
  { category_id: 11, wallpaper_id: 1014, is_default: false }, // nowoczesny
  { category_id: 3, wallpaper_id: 1015, is_default: true },
  // miasto (1016-1020) — grey/loft
  { category_id: 4, wallpaper_id: 1016, is_default: true },
  { category_id: 13, wallpaper_id: 1016, is_default: false }, // loft
  { category_id: 4, wallpaper_id: 1017, is_default: true },
  { category_id: 16, wallpaper_id: 1017, is_default: false }, // szary
  { category_id: 13, wallpaper_id: 1017, is_default: false }, // loft
  { category_id: 4, wallpaper_id: 1018, is_default: true },
  { category_id: 11, wallpaper_id: 1018, is_default: false }, // nowoczesny
  { category_id: 4, wallpaper_id: 1019, is_default: true },
  { category_id: 4, wallpaper_id: 1020, is_default: true },
  // abstrakcja (1021-1025) — modern styles
  { category_id: 5, wallpaper_id: 1021, is_default: true },
  { category_id: 11, wallpaper_id: 1021, is_default: false }, // nowoczesny
  { category_id: 5, wallpaper_id: 1022, is_default: true },
  { category_id: 15, wallpaper_id: 1022, is_default: false }, // niebieski
  { category_id: 5, wallpaper_id: 1023, is_default: true },
  { category_id: 16, wallpaper_id: 1023, is_default: false }, // szary
  { category_id: 5, wallpaper_id: 1024, is_default: true },
  { category_id: 18, wallpaper_id: 1024, is_default: false }, // zielony
  { category_id: 5, wallpaper_id: 1025, is_default: true },
  { category_id: 17, wallpaper_id: 1025, is_default: false }, // bialy
  // second batch — single category each
  { category_id: 1, wallpaper_id: 1026, is_default: true },
  { category_id: 2, wallpaper_id: 1027, is_default: true },
  { category_id: 3, wallpaper_id: 1028, is_default: true },
  { category_id: 4, wallpaper_id: 1029, is_default: true },
  { category_id: 5, wallpaper_id: 1030, is_default: true },
  { category_id: 1, wallpaper_id: 1031, is_default: true },
  { category_id: 2, wallpaper_id: 1032, is_default: true },
  { category_id: 3, wallpaper_id: 1033, is_default: true },
  { category_id: 4, wallpaper_id: 1034, is_default: true },
  { category_id: 5, wallpaper_id: 1035, is_default: true },
  { category_id: 1, wallpaper_id: 1036, is_default: true },
  { category_id: 2, wallpaper_id: 1037, is_default: true },
  { category_id: 3, wallpaper_id: 1038, is_default: true },
  { category_id: 4, wallpaper_id: 1039, is_default: true },
  { category_id: 5, wallpaper_id: 1040, is_default: true },
  { category_id: 1, wallpaper_id: 1041, is_default: true },
  { category_id: 2, wallpaper_id: 1042, is_default: true },
  { category_id: 3, wallpaper_id: 1043, is_default: true },
  { category_id: 4, wallpaper_id: 1044, is_default: true },
  { category_id: 5, wallpaper_id: 1045, is_default: true },
  { category_id: 1, wallpaper_id: 1046, is_default: true },
  { category_id: 2, wallpaper_id: 1047, is_default: true },
  { category_id: 3, wallpaper_id: 1048, is_default: true },
  { category_id: 4, wallpaper_id: 1049, is_default: true },
  { category_id: 5, wallpaper_id: 1050, is_default: true },
] as const;

CATEGORIES_WALLPAPERS.forEach((c) => CategoryWallpaperRow.parse(c));
